// Core packages
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

// Third party packages
import { formatDate } from "@angular/common";
import { MatDialog, MatRadioChange } from "@angular/material";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { MatProgressButtonOptions } from "mat-progress-buttons";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { finalize, tap } from "rxjs/operators";
// import * as FileSaver from "file-saver";
import * as FileSaver from "file-saver";

// Custom packages
import { AddDocumentsService } from "src/app/modules/add-documents/add-documents.service";
import { AuthService } from "src/app/modules/auth/auth.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import {
  AllDocsInterface
} from "src/app/modules/properties/documents.interface";
import DocumentTypeStructure from "src/app/modules/properties/documentTypes";
import { DocumentAreasInterface } from "src/app/modules/properties/documentTypes.interface";
import {
  ALL_FILES_DOC_TYPE_KEY,
  applyDocTypeToAllFiles,
  clearAllFilesDocTypeOnMismatch,
  fillNewFilesDocType,
  hasFilesNumber,
  withoutAllFilesDocType,
} from "src/app/modules/properties/paper-files-doc-type.utils";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { RolesService } from "src/app/modules/roles/roles.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { SuppliersService } from "src/app/modules/suppliers/suppliers.service";
import { PrintQrDialogComponent } from "src/app/shared/components/dialogs/print-qr-dialog/print-qr-dialog.component";
import { Company } from "src/app/shared/models/company/company.model";
import { PropertyInterface } from "src/app/shared/models/property/property.interface";
import { Property } from "src/app/shared/models/property/property.model";
import { IUser } from "src/app/shared/models/user/user.interface";
import { DateTimeFormatPipe } from "src/app/shared/pipes/date-format.pipe";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ThemeService } from "src/app/shared/services/theme.service";

@Component({
  selector: "app-add-documents",
  templateUrl: "./add-documents.page.html",
  styleUrls: ["./add-documents.page.scss"],
})
export class AddDocumentsComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  loggedUser: IUser;
  loggedUserPermissions: string[];
  loggedUserRole: any;
  currentRole: any;
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  // This cannot be a "Property" type because inside the "get" method in back-end
  // we are populating some fields, so the model is not the same!
  public property: Property;
  propertyData: PropertyInterface;
  loggedUserAdmin = false;
  dateTimeFormat: DateTimeFormatPipe;
  activeSection: string; // Active document section
  activeSectionData: any[] = [];
  itemId: string; // Id of active mapping section item
  condoStructure: any;
  documentArchive: any;
  documentArchiveId: string;
  allDocs: AllDocsInterface[] = [];
    sortedDocuments: any[] = [];
  public documentTypeStructure: DocumentTypeStructure =
    new DocumentTypeStructure();
  // documentArchiveIsLoading = true;
  showDocumentsExpired = true;
  insertDocuments = true;
  insertDocumentsSelected = false;
  insertDocumentsSelectedKey: any[] = [];
  company: Company = new Company();
  pageIsLoading = true;
  unitaImmobiliari = false;
  step0 = true;
  step1 = false;
  docsSelected: any[] = [];
  structureSelected: any[] = [];
  selectedStructureFree = "";
  canSubmitForm = true;
  dataIsLoading = false;
  docArea: DocumentAreasInterface;
  docTopics: any[] = [];
  docSubTopics: any[] = [];

  // BEGIN - Edit item form
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  propertyForm: FormGroup = new FormGroup({});
  propertyModel: any = {};
  propertyFields: FormlyFieldConfig[] = [];
  // END - ngx-formly

  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.save"),
    spinnerSize: 19,
    raised: true,
    stroked: false,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-save",
      inline: true,
    },
  };

  printModuleBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.printModule"),
    spinnerSize: 19,
    raised: false,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-print",
      inline: true,
    },
  };

  printQrBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.printLabel"),
    spinnerSize: 19,
    raised: false,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "accent",
    spinnerColor: "accent",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-qrcode",
      inline: true,
    },
  };
  // END - Edit item form

  previousPropertyId: any;
  previousDocTypes: any[] = [];
  selectedArea: any;
  code: string;
  docUploaded = false;
  selectedSubTopics = []; // used for displaying topic titles (AA: Dipendenti ecc...)
  checkboxesAreSelected = false;
  searchValue = "";
  acceptedType: string;
  editDocument = true;
  subscriptionType = "FULL";
  docType: string;
  previousDocType: string;

  contratti = false;

  // Dati aggiuntivi elenco/nuovo elemento
  suppliersName: any[] = [];
  yearsOfStorage: any[] = [];
  conductorName: any[] = [];
  nameInterventionArchiving: any[] = [];

  documentTemplateId = "";
  documentTemplate: any[] = [];

  isIncendioEvac = false;
  isSicurezzaAntincendioFacciate = false;

  /**
   * Class constructor
   */
  constructor(
    private configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private propertiesService: PropertiesService,
    private router: Router,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private themeService: ThemeService,
    private authService: AuthService,
    public dialog: MatDialog,
    private cookieService: CookieService,
    private apiService: ApiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    private condoStructuresService: CondoStructuresService,
    private rolesService: RolesService,
    private helperService: HelperService,
    private documentArchivesService: DocumentArchivesService,
    private companiesService: CompaniesService,
    private suppliersService: SuppliersService,
    private addDocumentsService: AddDocumentsService,
    private settingsService: SettingsService
  ) {
    
  }

  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // Set page title
    this.themeService.setPageTitle(
      this.translateService.instant("properties.documentsPage.pageTitle")
    );

    // Get current lang
    this.lang =
      this.cookieService.get("lang") || this.configService.defaultLang;

    // Get logged user data
    this.subscriptions.push(
      this.authService.loggedUser$.subscribe((res) => (this.loggedUser = res))
    );
    this.subscriptions.push(
      this.authService.loggedUserPermissions$.subscribe(
        (res) => (this.loggedUserPermissions = res)
      )
    );

    // Get logged user's role data
    this.currentRole = this.loggedUser.userRoles.find((obj: any) => {
      return (
        obj._id.toString() ===
        this.authService.loggedUserRequestedRole$.getValue().toString()
      );
    });
    this.loggedUserRole = this.currentRole.role;
    this.loggedUserAdmin =
      this.loggedUserRole.type === "admin" ||
      this.loggedUserRole.type === "operator";

    this.pageIsLoading = false;

    if (!this.loggedUserAdmin) {
      this.toastrService.error(
        this.translateService.instant("common.errors.not_authorized")
      );
      this.router.navigate([this.lang, "app"]);
      return;
    }

    this.subscriptions.push(
      this.settingsService.getDocument().subscribe(
        (res) => {
          if (res.status) {
            if (
              res.data &&
              Array.isArray(res.data) &&
              res.data.length > 0 &&
              res.data[0].area &&
              Array.isArray(res.data[0].area)
            ) {
              this.documentTemplateId = res.data[0]._id;
              this.documentTemplate = res.data[0].area;
            }
          }
        },
        (err) => {
          //
        }
      )
    );
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * init property field form
   *
   * @since 1.0.0
   */
  initPropertyForm(): void {
    this.propertyFields = [];

    // create default field to formly
    this.propertyFields = [
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-12",
            type: "autocomplete",
            key: "property",
            templateOptions: {
              label: this.translateService.instant(
                "properties.addDocumentsPage.property"
              ),
              placeholder: this.translateService.instant(
                "properties.addDocumentsPage.searchProperty"
              ),
              required: true,
              bindLabel: "name",
              bindValue: "_id",
              initialValues: this.propertyData
                ? [
                    {
                      _id: this.propertyData._id,
                      name: this.propertyData.name,
                    },
                  ]
                : undefined,
              search$: this.addDocumentsService.getList.bind(this),
              typeToSearchText: this.translateService.instant(
                "common.words.typeToSearch",
                { minTermLength: 1 }
              ),
              clearAllText: this.translateService.instant(
                "common.words.clearAll"
              ),
              notFoundText: this.translateService.instant(
                "common.words.notFound"
              ),
              loadingText: this.translateService.instant(
                "common.words.loading"
              ),
            },
            expressionProperties: {
              "templateOptions.onChange": (model: any) => {
                this.getPropertyData(model.property);
              },
            },
          },
        ],
      },
    ];
  }

  /**
   * init form
   *
   * @since 1.0.0
   */
  initForm(documentKey: string, schemaType: string): void {
    // Reset fields and form controls
    this.fields = [];
    const formControlKeys = Object.keys(this.form.controls);
    if (formControlKeys.length) {
      formControlKeys.forEach((key) => {
        this.form.removeControl(key);
      });
    }

    this.options.formState = {
      disabled: false,
    };

    // Create default common fields
    const defaultFields = [
      {
        className: "col-12 col-md-12 col-xl-12",
        type: "textarea",
        key: "contenutoDocumento",
        templateOptions: {
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.contenutoDocumento"
          ),
          placeholder: this.translateService.instant(
            "properties.detail.documentArchive.fields.contenutoDocumento"
          ),
          required: true,
          minLength: 2,
          maxLength: 500,
          rows: 5,
        },
        expressionProperties: {
          // apply expressionProperty for disabled based on formState
          "templateOptions.disabled": "formState.disabled",
        },
      },
      {
        className: "col-12 col-md-12 col-xl-12",
        type: "input",
        key: "protocollo",
        templateOptions: {
          readonly:false,
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.protocollo"
          ),
          placeholder: this.translateService.instant(
            "properties.detail.documentArchive.fields.protocollo"
          ),
          required: false,
          minLength: 0,
          maxLength: 500,
        },
      },
      {
        className: "col-12 col-md-12 col-xl-12",
        type: "textarea",
        key: "keyword",
        templateOptions: {
          readonly:false,
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.keyword"
          ),
          placeholder: this.translateService.instant(
            "properties.detail.documentArchive.fields.keyword"
          ),
          required: false,
          minLength: 0,
          maxLength: 1000,
          rows: 3
        },
      }
    ];

    // Create specific fields depending on document key: es AA1
    // const aryfields = this.documentTypeStructure.getFormlyFields(
    //   documentKey,
    //   false
    // );
    const aryfields = this.documentTypeStructure.getFormlyFields2(
      schemaType,
      false
    );
    //this.documentTemplate
    aryfields.forEach((item: any) => {
      if (item.templateOptions && item.templateOptions.placeholder) {
        item.templateOptions.placeholder = this.translateService.instant(
          item.templateOptions.placeholder
        );
      }
      if (item.type === "select") {
        if (Array.isArray(item.templateOptions.options)) {
          item.templateOptions.options.forEach((subItem: any) => {
            subItem.label = this.translateService.instant(subItem.label);
          });
        }
      }
      if (item.type === "selectNew") {
        item.type = "autocomplete";
        if (item.templateOptions.initialValues) {
          const options: any[] = [];
          switch (item.templateOptions.initialValues) {
            case "suppliersName":
              this.suppliersName.forEach((subItem: any) => {
                // options.push({
                //   value: subItem,
                //   label: subItem,
                // });
                options.push(subItem);
              });
              break;
            case "yearsOfStorage":
              this.yearsOfStorage.forEach((subItem: any) => {
                // options.push({
                //   value: subItem,
                //   label: subItem,
                // });
                options.push(subItem);
              });
              break;
            case "conductorName":
              this.conductorName.forEach((subItem: any) => {
                // options.push({
                //   value: subItem,
                //   label: subItem,
                // });
                options.push(subItem);
              });
              break;
            case "nameInterventionArchiving":
              this.nameInterventionArchiving.forEach((subItem: any) => {
                // options.push({
                //   value: subItem,
                //   label: subItem,
                // });
                options.push(subItem);
              });
              break;
          }
          item.templateOptions.initialValues = options;
          item.templateOptions.addTagText = this.translateService.instant(
            item.templateOptions.addTagText
          );
          item.templateOptions.customLabel = this.translateService.instant(
            item.templateOptions.customLabel
          );
        }
      }
      if (
        item.type === "autocomplete" ||
        item.type === "autocomplete-supplier"
      ) {
        item.templateOptions.addTagText = this.translateService.instant(
          item.templateOptions.addTagText
        );
        item.templateOptions.customLabel = this.translateService.instant(
          item.templateOptions.customLabel
        );
        if (item.templateOptions.search$ === "suppliersService") {
          item.templateOptions.search$ =
            this.suppliersService.getListV2.bind(this);
        }
      } else {
        if (item.templateOptions && item.templateOptions.label) {
          item.templateOptions.label = this.translateService.instant(
            item.templateOptions.label
          );
        }
      }
    });

    const fieldGroup = aryfields.concat(defaultFields);
    const itemConfig = [
      {
        fieldGroupClassName: "row",
        fieldGroup: fieldGroup,
      },
    ];

    this.fields = itemConfig;
    if (this.docType && this.docType === "digital") {
      this.fields.push({
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-12",
            type: "file-uploader",
            key: "documentFile",
            templateOptions: {
              required: true,
              allowedFilesNumber: 200,
              allowedFilesExtensions: this.configService.allowedDocumentExtensions,
              customLabel: this.translateService.instant(
                "properties.detail.documentArchive.fields.file"
              ),
            },
          },
        ],
      });
    } else if (this.docType && this.docType === "paper") {
      // Document types of a paper file: the same list feeds the radios of each file and the
      // "all files" radios next to "Numero di file", so the two always match
      const fileDocTypeOptions = [
        {
          value: "report",
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.report"
          ),
        },
        {
          value: "tables",
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.tables"
          ),
        },
        {
          value: "calcs",
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.calcs"
          ),
        },
        {
          value: "schemas",
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.schemas"
          ),
        },
        {
          value: "various",
          label: this.translateService.instant(
            "properties.detail.documentArchive.fields.various"
          ),
        },
      ];
      this.fields.push({
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-6",
            type: "input",
            key: "numFiles",
            hooks: {
              onInit: (field: any): void => {
                field.formControl.valueChanges
                  .pipe(
                    tap((value) => {
                      if (typeof value === "undefined") {
                        value = null;
                      }
                      if (value > field.templateOptions.max) {
                        value = field.templateOptions.max;
                      }
                      if (this.model.files) {
                        this.model.files.length = value;
                        // New files are born with the type picked for all files, if any
                        fillNewFilesDocType(
                          this.model.files,
                          this.model[ALL_FILES_DOC_TYPE_KEY]
                        );
                      }
                      this.model = {
                        ...this.model,
                        numFiles: value,
                      };
                    })
                  )
                  .subscribe();
              },
            },
            templateOptions: {
              type: "number",
              label: this.translateService.instant(
                "properties.detail.documentArchive.fields.numFiles"
              ),
              required: false,
              min: 2,
              max: 100,
            },
            expressionProperties: {
              // apply expressionProperty for disabled based on formState
              "templateOptions.disabled": "formState.disabled",
            },
          },
          {
            // Gives one type to all files at once, shown once "Numero di file" has a value. UI only:
            // each file sends its own docType, and onFormSubmit() strips this key from the payload
            className: "docs-radio-group-wrapper col-12 col-md-6",
            type: "radio",
            key: ALL_FILES_DOC_TYPE_KEY,
            hideExpression: (model: any) => !hasFilesNumber(model),
            hooks: {
              onInit: (field: FormlyFieldConfig) =>
                field.formControl.valueChanges.pipe(
                  tap((docType) =>
                    applyDocTypeToAllFiles(this.form.get("files"), docType)
                  )
                ),
            },
            templateOptions: {
              label: this.translateService.instant(
                "properties.detail.documentArchive.fields.allFilesDocType"
              ),
              options: fileDocTypeOptions,
            },
            expressionProperties: {
              // apply expressionProperty for disabled based on formState
              "templateOptions.disabled": "formState.disabled",
            },
          },
          {
            className: "docs-radio-group-wrapper col-12",
            key: "files",
            type: "repeat",
            expressionProperties: {
              // apply expressionProperty for disabled based on formState
              "templateOptions.disabled": "formState.disabled",
            },
            fieldArray: {
              fieldGroup: [
                {
                  className: "pl-0 col-12 col-md-6",
                  type: "input",
                  key: "name",
                  hooks: {
                    onInit(field) {
                      const type = field.parent.fieldGroup[1].defaultValue[0]; // take first letter from radio's defaultValue
                      const name = this.barCode; // barcode value
                      const index = +field.parent.key + 1; // actual array index plus 1
                      field.defaultValue =
                        `${name}_${type}${index}`.toUpperCase();
                    },
                  },
                  templateOptions: {
                    label: this.translateService.instant(
                      "properties.detail.documentArchive.fields.name"
                    ),
                    placeholder: this.translateService.instant(
                      "properties.detail.documentArchive.fields.name"
                    ),
                    minLength: 0,
                    maxLength: 500,
                    readonly: true,
                  },
                },
                {
                  className: "col-12 col-md-6",
                  type: "radio",
                  key: "docType",
                  defaultValue: "report",
                  hooks: {
                    // This file got another type: the "all files" choice no longer holds
                    onInit: (field: FormlyFieldConfig) =>
                      field.formControl.valueChanges.pipe(
                        tap((docType) =>
                          clearAllFilesDocTypeOnMismatch(
                            this.form.get(ALL_FILES_DOC_TYPE_KEY),
                            docType
                          )
                        )
                      ),
                  },
                  expressionProperties: {
                    "templateOptions.onChange": (
                      model: any,
                      opt: any,
                      field: any
                    ) => {
                      if (model) {
                        const position = +field.parent.key;

                        // @todo: da rivedere (segnalato in #105)
                        // Return if no changes were made
                        // if (
                        //   this.previousDocTypes.map(el => el.value).includes(field.formControl.value)
                        //   && this.previousDocTypes.map(el => el.position).includes(position)
                        // ) {
                        //   return;
                        // }
                        // this.previousDocTypes = [];
                        // field.parent.parent.fieldGroup.forEach(el => {
                        //   this.previousDocTypes.push({
                        //     position,
                        //     value: el.formControl.value.docType
                        //   });
                        // });

                        const type = model.docType[0]; // take first letter from radio's actual value
                        const name = this.code; // barcode value
                        const index = position + 1; // actual array index plus 1;

                        // Set new value in model
                        model.name = `${name}_${type}${index}`.toUpperCase();

                        // Set new value in field (make it change inside form input)
                        field.parent.fieldGroup[0].formControl.setValue(
                          model.name
                        );
                      }
                    },
                  },
                  templateOptions: {
                    label: this.translateService.instant(
                      "properties.detail.documentArchive.fields.docType"
                    ),
                    options: fileDocTypeOptions,
                  },
                },
              ],
            },
          },
        ],
      });
    } else {
      this.toastrService.error("Error: no docType selected");
    }
  }

  /**
   * Get current property data
   *
   * @since 1.0.0
   */
  getPropertyData(propId: string): void {
    if (propId === this.previousPropertyId) {
      return;
    }

    this.editDocument = true;

    // Get requested property data, company data and document archive
    this.previousPropertyId = propId;

    if (!propId) {
      // Reset data
      this.property = undefined;
      this.resetData();
      return;
    }

    // Activate spinner for radio group (deactivate in setVisibleDocsByStructures())
    this.dataIsLoading = true;

    this.resetData();

    this.subscriptions.push(
      this.propertiesService.get(propId).subscribe(
        (res) => {
          if (res.status) {
            this.property = new Property();
            this.property.setData(res.data);
            this.propertyData = res.data;

            if (
              this.propertyData.subscription &&
              this.propertyData.subscription.key
            ) {
              this.subscriptionType = this.propertyData.subscription.key;
            }

            // Generate document code - just for Paper Doc
            const total = (
              +this.property.get("totalDocsProgressive") + 1
            ).toString();
            this.code = `${this.property.getId()}S${total.padStart(6, "0")}C`;

            if (
              this.propertyData.admin &&
              this.propertyData.admin.company &&
              this.propertyData.admin.company._id
            ) {
              this.subscriptions.push(
                this.companiesService
                  .get(this.propertyData.admin.company._id)
                  .subscribe((res) => {
                    if (res.status) {
                      this.company.setData(res.data);
                    }
                  })
              );
            }

            // If property has a structure ID, than retrive related data
            // and document archive
            if (
              this.subscriptionType !== "FREE" && 
              this.subscriptionType !== 'FREEBASIC' &&
              this.propertyData.structure
            ) {
              this.getStructureData();
            } else if (this.subscriptionType === "FREE" || this.subscriptionType === 'FREEBASIC') {
              if (this.propertyData.documentArchive) {
                this.documentArchiveId = this.propertyData.documentArchive;
                this.getDocumentArchiveData();
              }
            } else {
              this.pageIsLoading = false;
            }
            return;
          }
        },
        (err) => {
          // if we came here property do not exists
          this.helperService.handleError(err);
        }
      )
    );
  }

  /**
   * Init form basing on docType
   *
   * @since 1.0.0
   */
  onChooseDocType(type: string): void {
    this.docType = type;
    setTimeout(() => {
      this.initPropertyForm();

      if (this.docType === "digital") {
        this.watchFileChanges();
      }
    }, 500);
  }

  /**
   * Watch for file-uploader changes, if file was uploaded
   * scroll down on dialog bottom
   *
   * @since 1.0.0
   */
  watchFileChanges(): void {
    if (this.form.controls["documentFile"]) {
      this.subscriptions.push(
        this.form.controls["documentFile"].valueChanges.subscribe(
          (res) => {
            // A file was uploaded, scroll down dialog
            if (Array.isArray(res) && res.length) {
              const dialogWindow = document.getElementsByTagName(
                "mat-dialog-container"
              )[0]; // assuming we can have only one dialog opened
              if (dialogWindow) {
                const contentToScroll =
                  dialogWindow.getElementsByClassName("mat-dialog-content");
                if (contentToScroll[0]) {
                  const bottomHeight = contentToScroll[0].scrollHeight;
                  contentToScroll[0].scrollTo({
                    top: bottomHeight,
                    behavior: "smooth",
                  });
                }
              }
            }
          },
          (err) => {
            this.helperService.handleError(err);
          }
        )
      );
    }
  }

  resetData(): void {
    this.selectedArea = undefined;
    this.docArea = this.documentTypeStructure.getDocumentArea2(undefined, this.documentTemplate);
    this.model = {};
    this.docTopics = [];
    this.docSubTopics = [];
    this.selectedSubTopics = [];
    this.docsSelected = [];
    this.checkboxesAreSelected = false;
    this.docUploaded = false;

    // Enable form fields
    Object.keys(this.form.controls).forEach((key) => {
      const control = this.form.controls[key];
      if (control && control.disabled) {
        control.reset();
        control.enable();
      }
    });
  }

  /**
   * Get current property structure data and populate
   * this.condoStructure,
   * Then get archive document.
   *
   * @since 1.0.0
   */
  getStructureData(): void {
    this.condoStructuresService
      .get(this.property.get("structure"))
      .subscribe((res) => {
        if (res.status) {
          this.condoStructure = res.data;
          if (this.condoStructure.open) {
            if (this.subscriptionType !== "FREE" && this.subscriptionType !== 'FREEBASIC') {
              this.editDocument = false;
            }
          } else {
            // If property has a document Archive ID, than retrieve related data
            if (this.propertyData.documentArchive) {
              this.documentArchiveId = this.propertyData.documentArchive;
              this.getDocumentArchiveData();
            }
          }
        } else {
          this.pageIsLoading = false;
          this.toastrService.error(res.message);
        }
      });
  }

  /**
   * Get current property documentArchive data and populate
   * this.documentArchive
   *
   * @since 1.0.0
   */
  getDocumentArchiveData(): void {
    this.documentArchivesService
      .get(this.property.get("documentArchive"))
      .subscribe((res) => {
        if (res.status) {
          this.documentArchive = res.data;
          this.pageIsLoading = false;
          this.setVisibleDocsByStructures();
          if (this.documentArchive.suppliersName) {
            this.suppliersName = this.documentArchive.suppliersName;
          }
          if (this.documentArchive.yearsOfStorage) {
            this.yearsOfStorage = this.documentArchive.yearsOfStorage;
          }
          if (this.documentArchive.conductorName) {
            this.conductorName = this.documentArchive.conductorName;
          }
          if (this.documentArchive.nameInterventionArchiving) {
            this.nameInterventionArchiving =
              this.documentArchive.nameInterventionArchiving;
          }
        } else {
          this.pageIsLoading = false;
          this.toastrService.error(res.message);
        }
      });
  }

  /**
   * Get selected area of documents
   *
   * @since 1.0.0
   */
  onChangeArea($event: MatRadioChange): void {
    const area = this.selectedArea ? this.selectedArea.toString() : undefined;
    this.docArea = undefined;
    if ($event.source.name === "radioArea") {
      // Get selected area children (es: A, B...)
      this.docArea = JSON.parse(
        JSON.stringify(this.documentTypeStructure.getDocumentArea2(area, this.documentTemplate))
      );
      this.setVisibleDocsByStructures();
    }
    this.dataIsLoading = false;

    // Reset children
    this.docTopics = [];
    this.docSubTopics = [];
    this.selectedSubTopics = [];
    this.docsSelected = [];
    this.checkboxesAreSelected = false;
  }

  /**
   * Handle select subdocuments
   *
   * @since 1.0.0
   */
  onChangeTopic(code: string, checked: boolean): void {
    if (checked) {
      // Get selected topic children (es: AA, AB...)
      this.docTopics = [
        ...this.docTopics,
        ...JSON.parse(
          JSON.stringify(
            this.documentTypeStructure.getDocumentTopic2(
              code,
              this.documentTemplate,
              this.condoStructure
            )
          )
        ),
      ];
      if (this.docTopics[0].rawTitle === "contratti") {
        this.contratti = true;
      } else {
        this.contratti = false;
      }

      // Filter on "incendioEvac" and "sicurezzaAntincendioFacciate"
      // if (!this.isIncendioEvac) { 
      //   this.docTopics = this.docTopics.filter(
      //     (el: any) => el.rawTitle !== "incendioEvac"); 
      // }
      if (!this.isSicurezzaAntincendioFacciate) { 
        this.docTopics = this.docTopics.filter(
          (el: any) => el.rawTitle !== "sicurezzaAntincendioFacciate"); 
      } 
    } else {
      this.docTopics = this.docTopics.filter((doc) => doc.parent !== code);
      this.selectedSubTopics = this.selectedSubTopics.filter(
        (subTopic) => subTopic.parent !== code
      );

      // Leave only items with same parent as the remaining selectedSubTopics
      const selectedCodes = this.selectedSubTopics.map((el) => el.code);
      this.docSubTopics = this.docSubTopics.filter((subDoc) =>
        selectedCodes.includes(subDoc.parent)
      );

      // If no checkbox is selected, set acceptedType to undefined
      // This makes all checkboxes enabled
      if (
        this.docSubTopics.every((el) => !el.value) ||
        !this.selectedSubTopics.length
      ) {
        this.acceptedType = undefined;
        this.checkboxesAreSelected = false;
      }
    }
  }

  /**
   * Handle select subdocuments
   *
   * @since 1.0.0
   */
  onChangeSubTopic(subTopic: any, checked: boolean, parentCode: string): void {
    if (!subTopic) {
      this.toastrService.error("No subTopics injected");
      return;
    }

    let subscriptionFree = false;
    if (this.subscriptionType === "FREE" || this.subscriptionType === "FREEBASIC") {
      subscriptionFree = true;
    }

    if (checked) {
      // Get selected subTopic children (es: AA1, AA2...)
      let docSubTopics = JSON.parse(
        JSON.stringify(
          this.documentTypeStructure.getDocumentSubTopic2(
            subTopic.code,
            parentCode,
            this.documentTemplate,
            this.condoStructure,
            subscriptionFree,
            this.lang
          )
        )
      );
      if (this.contratti && this.subscriptionType !== "FREE" && this.subscriptionType !== 'FREEBASIC') {
        this.contratti = true;
      }

      docSubTopics = docSubTopics.filter((el: any) => !el.deleted);

      this.docSubTopics = [...this.docSubTopics, ...docSubTopics];

      // Add to displayed array
      this.selectedSubTopics.push(subTopic);
    } else if (!checked) {
      // Remove from arrays
      this.docSubTopics = this.docSubTopics.filter(
        (doc) => doc.parent !== subTopic.code
      );

      const index = this.selectedSubTopics
        .map((el) => el.code)
        .indexOf(subTopic.code);
      this.selectedSubTopics.splice(index, 1);
    }

    // Eliminate duplicates
    this.docSubTopics = this.docSubTopics.filter(
      (topic, index, self) =>
        self.findIndex((t) => t.code === topic.code) === index
    );

    // If no checkbox is selected, set acceptedType to undefined
    if (
      this.docSubTopics.every((el) => !el.value) ||
      !this.selectedSubTopics.length
    ) {
      this.acceptedType = undefined;
      this.checkboxesAreSelected = false;
    }

    // Sort displayed data in alphabetical order
    this.selectedSubTopics.sort((a, b) => a.code.localeCompare(b.code));
  }

  /**
   * Handle enable same docs type
   *
   * @since 1.0.0
   */
  onSetSubDoc(code: string, checked: boolean): void {
    const type = JSON.parse(
      JSON.stringify(this.documentTypeStructure.getDocumentType2(code, this.documentTemplate))
    );

    if (checked) {
      this.acceptedType = type;
    }

    // set this if at least one checkbox is selected
    this.checkboxesAreSelected = false;

    this.docSubTopics.forEach((el: any) => {
      const subType = JSON.parse(
        JSON.stringify(this.documentTypeStructure.getDocumentType2(el.code, this.documentTemplate))
      );

      if (!checked) {
        // If the unchecked item is the only one with this type, remove acceptedType
        if (!el.value) {
          this.acceptedType === undefined;
        }
        if (el.code !== code && el.value) {
          this.checkboxesAreSelected = true;
        }
      } else {
        this.checkboxesAreSelected = true;
      }
    });
  }

  /**
   * Handle filter on docs
   *
   * @since 1.0.0
   */
  applyFilter(event: Event): void {
    this.searchValue = (event.target as HTMLInputElement).value;
    const regex = new RegExp(this.searchValue.trim().toLowerCase(), "gi");

    this.docSubTopics.forEach((el: any) => {
      if (
        (el.title && el.title.search(regex) > -1) ||
        el.code.search(regex) > -1
      ) {
        el.visible = true;
      } else {
        el.visible = false;
        el.value = false;
      }
    });
  }

  /**
   * Handle go back to initial step
   *
   * @since 1.0.0
   */
  onStep0(): void {
    this.step0 = true;
    this.step1 = false;
    if (!this.docUploaded) {
      // If documents were not uploaded yet, reinit form
      this.initPropertyForm();
      this.docsSelected = [];
      return;
    } else {
      // Documents uploaded: reset property data
      this.docType = undefined;
      this.property = undefined;
      this.getPropertyData(undefined);
    }
  }

  /**
   * Handle step insert data
   *
   * @since 1.0.0
   */
  onStep1(): void {
    // Return if button is disabled
    if (!this.checkboxesAreSelected) {
      return;
    }

    this.step0 = false;
    this.step1 = true;
    let key = "";
    let schemaType = "";
    this.structureSelected = [];
    let contractStructures = [];

    if (this.contratti) {
      if (this.subscriptionType !== "FREE" && this.subscriptionType !== 'FREEBASIC') {
        this.docSubTopics.forEach((subEl: any) => {
          contractStructures = [];
          if (subEl.value) {
            key = subEl.code;
            schemaType = subEl.schemaType;
            if (subEl.origin) {
              // Get structures
              for (const docs of this.documentTemplate) {
                if (!docs.deleted) {
                  const content = docs.content;
                  if (content && Array.isArray(content)) {
                    let index = -1;
                    if (subEl.origin === "impelegenerale-contratti") {
                      index = content.findIndex((subDocs: any) => {
                        return (
                          subDocs.title.replace("properties.documents.", "") ===
                          "impelegenerale"
                        );
                      });
                    } else if (subEl.origin === "impeleMediaTensione-contratti") {
                      index = content.findIndex((subDocs: any) => {
                        return (
                          subDocs.title.replace("properties.documents.", "") ===
                          "impeleMediaTensione"
                        );
                      });
                    } else {
                      index = content.findIndex((subDocs: any) => {
                        return (
                          subDocs.title.replace("properties.documents.", "") ===
                          subEl.origin
                        );
                      });
                    }

                    if (index > -1) {
                      let structure = "";
                      if (subEl.origin === "impelegenerale-contratti") {
                        structure = "fornituraBt";
                      } else if (subEl.origin === "impeleMediaTensione-contratti") {
                        structure = "fornituraMt";
                      } else {
                        structure = content[index].structure;
                      }

                      if (structure && structure !== "") {
                        contractStructures = [];
                        this.condoStructure[structure].forEach((item: any) => {
                          if (
                            typeof item.active !== "undefined" &&
                            item.active
                          ) {
                            switch (structure) {
                              case "fornituraBt":
                                contractStructures.push({
                                  id: item._id,
                                  name: `${item.nome} - ${item.codicePod}`,
                                  value: false,
                                  type: "fornituraBt",
                                });
                                break;
                              case "fornituraMt":
                                contractStructures.push({
                                  id: item._id,
                                  name: `${item.nome} - ${item.numeroContrattofornitur}`,
                                  value: false,
                                  type: "fornituraMt",
                                });
                                break;
                              // case "estintori":
                              //   contractStructures.push({
                              //     id: item._id,
                              //     name: "Estintori", // item.nome,
                              //     value: false,
                              //     type: "estintori",
                              //   });
                              //   break;
                              case "contatoriAcqua":
                                contractStructures.push({
                                  id: item._id,
                                  name: `${item.nome} - ${item.codiceUtente}`,
                                  value: false,
                                  type: "contatoriAcqua",
                                });
                                break;
                              case "contatoreGas":
                                contractStructures.push({
                                  id: item._id,
                                  name: `${item.nome} - ${item.codicePdr}`,
                                  value: false,
                                  type: "contatoreGas",
                                });
                                break;
                              case "ascensore":
                                contractStructures.push({
                                  id: item._id,
                                  name: `${item.nome} - ${item.numeroMatricola}`,
                                  value: false,
                                  type: "ascensore",
                                });
                                break;
                              case "montauto":
                                contractStructures.push({
                                  id: item._id,
                                  name: `${item.nome} - ${item.numeroMatricola}`,
                                  value: false,
                                  type: "montauto",
                                });
                                break;
                              default: 
                                contractStructures.push({
                                  id: item._id,
                                  name: item.nome,
                                  value: false,
                                  type: structure,
                                });
                            }
                          }
                        });
                        
                        
                      }
                      break;
                    }
                  }
                }
              }
              
              if (
                subEl.origin === "impelegenerale-contratti" ||
                subEl.origin === "impeleMediaTensione-contratti"
              ) {
                this.docsSelected.push({
                  subDoc: "contratti",
                  subAreaTitle: subEl.subAreaTitle,
                  title: subEl.title,
                  key: subEl.code,
                  schemaType: subEl.schemaType,
                  structureSelected: contractStructures,
                });
              } else {
                this.docsSelected.push({
                  subDoc: subEl.origin,
                  subAreaTitle: subEl.subAreaTitle,
                  title: subEl.title,
                  key: subEl.code,
                  schemaType: subEl.schemaType,
                  structureSelected: contractStructures,
                });
              }
            } else {
              this.docsSelected.push({
                subDoc: "contratti",
                subAreaTitle: subEl.subAreaTitle,
                title: subEl.title,
                key: subEl.code,
                schemaType: subEl.schemaType,
                structureSelected: [],
              });
            }

            if (contractStructures.length) {
              contractStructures.forEach((el: any) => {
                const structure = {
                  id: el.id,
                  name: el.name,
                  value: false,
                  type: el.type,
                };
                this.structureSelected.push(structure);
              });
            }
          }
        });
      } else {
        this.docSubTopics.forEach((subEl: any) => {
          contractStructures = [];
          if (subEl.value) {
            key = subEl.code;
            schemaType = subEl.schemaType;
            if (subEl.origin) {
              if (
                subEl.origin === "impelegenerale-contratti" ||
                subEl.origin === "impeleMediaTensione-contratti"
              ) {
                this.docsSelected.push({
                  subDoc: "contratti",
                  subAreaTitle: subEl.subAreaTitle,
                  title: subEl.title,
                  key: subEl.code,
                  schemaType: subEl.schemaType,
                  structureSelected: contractStructures,
                });
              } else {
                this.docsSelected.push({
                  subDoc: subEl.origin,
                  subAreaTitle: subEl.subAreaTitle,
                  title: subEl.title,
                  key: subEl.code,
                  schemaType: subEl.schemaType,
                  structureSelected: contractStructures,
                });
              }
            } else {
              this.docsSelected.push({
                subDoc: "contratti",
                subAreaTitle: subEl.subAreaTitle,
                title: subEl.title,
                key: subEl.code,
                schemaType: subEl.schemaType,
                structureSelected: [],
              });
            }
          }
        });

        this.selectedStructureFree = "-1";
      }
    } else {
      this.docTopics.forEach((el: any) => {
        let structures = false;
        this.docSubTopics.forEach((subEl: any) => {
          // If element was selected and belongs to parent
          if (subEl.parent === el.code && subEl.value) {
            // Prevent entering duplicates
            key = subEl.code;
            schemaType = subEl.schemaType;
            const keys = this.docsSelected.map((subSubEl) => subSubEl.key);
            if (keys.includes(key)) {
              return;
            }

            const title = el.title.replace("properties.documents.", "");
            if (this.subscriptionType !== "FREE" && this.subscriptionType !== 'FREEBASIC') {
              for (const docs of this.documentTemplate) {
                if (!docs.deleted) {
                  const content = docs.content;
                  if (content && Array.isArray(content)) {
                    const index = content.findIndex((subDocs: any) => {
                      return (
                        subDocs.title.replace("properties.documents.", "") === title
                      );
                    });
                    if (index > -1) {
                      let structure = "";
                      if (title === "incendioEvac") {
                        structure = "evac";
                      } else {
                        structure = content[index].structure;
                      }

                      if (structure && structure !== "") {
                        this.condoStructure[structure].forEach((item: any) => {
                          if (
                            typeof item.active !== "undefined" &&
                            item.active
                          ) {
                            const ids = this.structureSelected.map(
                              (el) => el.id
                            );
                            let name = item.nome;
                            switch (structure) {
                              case "dipendenti":
                                name = `${item.nome} ${item.cognome}`;
                                break;
                              case "contatoreGas":
                                name = `${item.nome} - ${item.codicePdr}`;
                                break;
                              case "ascensore":
                                name = `${item.nome} - ${item.numeroMatricola}`;
                                break;
                              case "montauto":
                                name = `${item.nome} - ${item.numeroMatricola}`;
                                break;
                              case "contatoriAcqua":
                                name = `${item.nome} - ${item.codiceUtente}`;
                                break;
                              // case "estintori":
                              //   name = "Estintori";
                              //   break;
                            }
                            const selStructure = {
                              id: item._id,
                              name,
                              value: false,
                              type: structure,
                            };
                            // Prevent duplicate insert
                            if (ids.includes(selStructure.id)) {
                              subEl = {
                                ...subEl,
                                structureSelected:
                                  this.structureSelected.filter(
                                    (el) => el.type === selStructure.type
                                  ),
                              };
                              return;
                            }
                            this.structureSelected.push(selStructure);
                            subEl = {
                              ...subEl,
                              structureSelected: this.structureSelected.filter(
                                (el) => el.type === selStructure.type
                              ),
                            };
                          }
                        });
                      } else {
                        if (title === "vvFdefinitivo") {

                          if (
                            this.documentArchive.vvFdefinitivo &&
                            Array.isArray(this.documentArchive.vvFdefinitivo)
                          ) {
                            this.documentArchive.vvFdefinitivo.forEach((item: any) => {
                              
                                if (item.structureObjectType !== "") {
                                  const ids = this.structureSelected.map((el) => el.id);
                                  const structure = {
                                    id: item.structureObjectId,
                                    name: item.structureObjectName,
                                    value: false,
                                    type: "vvFdefinitivo",
                                    typeStructure: item.structureObjectType,
                                  };
                                  // Prevent duplicate insert
                                  if (ids.includes(structure.id)) {
                                    subEl = {
                                      ...subEl,
                                      structureSelected: this.structureSelected.filter(
                                        (el) => el.type === structure.type
                                      ),
                                    };
                                    return;
                                  }
                                  this.structureSelected.push(structure);
                                  subEl = {
                                    ...subEl,
                                    structureSelected: this.structureSelected.filter(
                                      (el) => el.type === structure.type
                                    ),
                                  };
                                } else if (item.structureObjectId === "-1") {
                                  const structure = {
                                    id: item.structureObjectId,
                                    name: this.lang === "it" ? `Edificio uso terziario ${item.structureObjectName}` : `Tertiary use building ${item.structureObjectName}`,
                                    value: false,
                                    type: "vvFdefinitivo",
                                    typeStructure: item.structureObjectType,
                                  };
                                  this.structureSelected.push(structure);
                                  subEl = {
                                    ...subEl,
                                    structureSelected: this.structureSelected.filter(
                                      (el) => el.type === structure.type
                                    ),
                                  };
                                }
                              
                            });
                          }
                          if (
                            this.condoStructure.attivitavvf &&
                            Array.isArray(this.condoStructure.attivitavvf)
                          ) {
                            const attivitavvf = this.condoStructure.attivitavvf.filter(
                              (el: any) => 
                                !this.structureSelected.find(
                                  (subEl: any) => 
                                    subEl.id && 
                                    el._id && 
                                    subEl.id.toString() === el._id.toString()
                                )
                            );
                            for (const item of attivitavvf) {
                              this.structureSelected.push({
                                id: item._id, 
                                name: item.nome, 
                                value: false, 
                                type: 'vvFdefinitivo', 
                                typeStructure: 'attivitavvf'
                              });
                            }
                            subEl = {
                              ...subEl,
                              structureSelected: this.structureSelected.filter(
                                (el) => el.type === 'vvFdefinitivo'
                              ),
                            };
                          }
                        }
                      }
                      break;
                    }
                  }
                }
              }
              this.docsSelected.push({
                subDoc: title,
                subAreaTitle: subEl.subAreaTitle,
                title: subEl.title,
                key,
                schemaType: subEl.schemaType,
                structureSelected: subEl.structureSelected,
              });
              structures = true;
            } else {
              for (const docs of this.documentTemplate) {
                if (!docs.deleted) {
                  const content = docs.content;
                  if (content && Array.isArray(content)) {
                    const index = content.findIndex((subDocs: any) => {
                      return (
                        subDocs.title.replace("properties.documents.", "") === title
                      );
                    });
                    if (index > -1) {
                      const structure = content[index].structure;
                      if (structure && structure !== "") {
                        this.selectedStructureFree = "-1";
                        this.docsSelected.push({
                          subDoc: title,
                          subAreaTitle: subEl.subAreaTitle,
                          title: subEl.title,
                          key,
                          schemaType,
                          structureSelected: "-1",
                        });
                        structures = true;
                      } else {
                        if (title === "vvFdefinitivo") {
                          this.selectedStructureFree = "-1";
                          this.docsSelected.push({
                            subDoc: title,
                            subAreaTitle: subEl.subAreaTitle,
                            title: subEl.title,
                            key,
                            schemaType,
                            structureSelected: "-1",
                          });
                          structures = true;
                        } else {
                          this.docsSelected.push({
                            subDoc: title,
                            subAreaTitle: subEl.subAreaTitle,
                            title: subEl.title,
                            key,
                            schemaType,
                            structureSelected: undefined,
                          });
                        }
                      }
                      break;
                    }
                  }
                }
              }
              
            }
          }

          // Sort displayed data in alphabetical order
          // this.docsSelected.sort((a, b) => a.code.localeCompare(b.code));
        });
      });
    }

    if (this.structureSelected.length) {
      this.canSubmitForm = false;
    } else {
      this.canSubmitForm = true;
    }

    this.initForm(key, schemaType);
  }

  /**
   * Enable/Disable docs depend on inserted structure
   *
   * @since 1.0.0
   */
  setVisibleDocsByStructures(): void {
    // Check "unitaImmobiliari"
    this.unitaImmobiliari = false;
    const ui = this.documentTemplate.find((docs: any) => {
      return docs.group === "unitaImmobiliari";
    });
    if (ui && ui.content && Array.isArray(ui.content)) {
      this.unitaImmobiliari = ui.content.some((subDoc: any) => {
        const title = subDoc.title.replace("properties.documents.", "")
        if (this.documentArchive[title] && this.documentArchive[title].length) {
          return true;
        }
      });
    }
    
    

    this.dataIsLoading = false;
    if (
      this.docArea &&
      this.docArea.content &&
      Array.isArray(this.docArea.content)
    ) {
      let allSubElementsVisible = false;
      this.docArea.content.forEach((el: any) => {
        if (el.content && Array.isArray(el.content)) {
          allSubElementsVisible = false;
          el.content.forEach((subEl: any) => {
            const title = subEl.title.replace("properties.documents.", "");
            if (this.subscriptionType !== "FREE" && this.subscriptionType !== 'FREEBASIC') {
              for (const docs of this.documentTemplate) {
                if (!docs.deleted) {
                  const content = docs.content;
                  if (content && Array.isArray(content)) {
                    const index = content.findIndex((subDocs: any) => {
                      return (
                        subDocs.title.replace("properties.documents.", "") === title
                      );
                    });
                    if (index > -1) {
                      const structure = content[index].structure;
                      if (structure && structure !== "") {
                        if (
                            this.condoStructure[structure] && 
                            Array.isArray(this.condoStructure[structure]) && 
                            this.condoStructure[structure].length > 0
                          ) {
                          subEl.visible = true;
                          allSubElementsVisible = true;
                        } else {
                          subEl.visible = false;
                        }
                      } else if (title==="impelegenerale") {
                        if (
                          this.condoStructure && 
                          this.condoStructure["fornituraBt"] &&
                          Array.isArray(this.condoStructure["fornituraBt"]) &&
                          this.condoStructure["fornituraBt"].length > 0
                        ) {
                          subEl.visible = true;
                          allSubElementsVisible = true;
                        } else {
                          subEl.visible = false;
                        }
                      } else if (title==="impeleMediaTensione") {
                        if (
                          this.condoStructure && 
                          this.condoStructure["fornituraMt"] &&
                          Array.isArray(this.condoStructure["fornituraMt"]) &&
                          this.condoStructure["fornituraMt"].length > 0
                        ) {
                          subEl.visible = true;
                          allSubElementsVisible = true;
                        } else {
                          subEl.visible = false;
                        }
                      } else if (title==="sicurezzaAntincendioFacciate") {
                        if (
                          this.condoStructure && 
                          this.condoStructure["fabbricatoAbitativo"] &&
                          Array.isArray(this.condoStructure["fabbricatoAbitativo"]) &&
                          this.condoStructure["fabbricatoAbitativo"].length > 0
                        ) {
                          subEl.visible = false;
                          for (const fabbricatoAbitativo of this.condoStructure["fabbricatoAbitativo"]) {
                            if (
                              fabbricatoAbitativo.altezzaAntincendio !== " " &&
                              fabbricatoAbitativo.altezzaAntincendio !== "12<"
                            ) {
                              subEl.visible = true;
                              allSubElementsVisible = true;
                              this.isSicurezzaAntincendioFacciate = true;
                            }
                          }
                        } else {
                          subEl.visible = false;
                        }
                      } else if (title==="incendioEvac") {
                        if (
                          this.condoStructure && 
                          this.condoStructure["fabbricatoAbitativo"] &&
                          Array.isArray(this.condoStructure["fabbricatoAbitativo"]) &&
                          this.condoStructure["fabbricatoAbitativo"].length > 0
                        ) {
                          subEl.visible = false;
                          for (const fabbricatoAbitativo of this.condoStructure["fabbricatoAbitativo"]) {
                            if (
                              fabbricatoAbitativo.altezzaAntincendio === "54< H <=80" ||
                              fabbricatoAbitativo.altezzaAntincendio === ">80"
                            ) {
                              subEl.visible = true;
                              allSubElementsVisible = true;
                              this.isIncendioEvac = true;
                            }
                          }
                        } else {
                          subEl.visible = false;
                        }
                      } else if (title==="vvFdefinitivo") {
                        if (
                          this.documentArchive && 
                          this.documentArchive["vvFdefinitivo"] &&
                          Array.isArray(this.documentArchive["vvFdefinitivo"]) &&
                          this.documentArchive["vvFdefinitivo"].length > 0
                        ) {
                          subEl.visible = true;
                          allSubElementsVisible = true;
                        } else {
                          subEl.visible = false;
                        }
                      } else {
                        allSubElementsVisible = true;
                      }
                      break;
                    }
                  }
                }
              }
              
            } else {
              if (title === "") {
                this.contratti = true;
                this.selectedStructureFree = "-1";
              } else {
                for (const docs of this.documentTemplate) {
                  if (!docs.deleted) {
                    const content = docs.content;
                    if (content && Array.isArray(content)) {
                      const index = content.findIndex((subDocs: any) => {
                        return (
                          subDocs.title.replace("properties.documents.", "") === title
                        );
                      });
                      if (index > -1) {
                        this.selectedStructureFree = "-1";
                        break;
                      }
                    }
                  }
                }
              }
              
            }
          });
          if (this.subscriptionType !== "FREE" && this.subscriptionType !== 'FREEBASIC') {
            el.visible = allSubElementsVisible;
          }
        }
      });
    }
  }

  /**
   * Check which structures are selected and then enable submit button
   *
   * @since 1.0.0
   */
  onChangePlant(): void {
    if (this.contratti) {
      this.canSubmitForm = true;
      if (this.docsSelected && this.docsSelected.length) {
        this.docsSelected.forEach((el: any) => {
          if (
            Array.isArray(el.structureSelected) &&
            el.structureSelected.length
          ) {
            if (!el.structureSelected.some((subEl) => subEl.value)) {
              this.canSubmitForm = false;
            }
          }
        });
      }
    } else {
      this.canSubmitForm = false;
      if (this.structureSelected && this.structureSelected.length) {
        if (this.structureSelected.some((el) => el.value)) {
          this.canSubmitForm = true;
        }
      }
    }
  }

  /**
   * Handle form submit
   *
   * @since 1.0.0
   */
  onFormSubmit(): void {
    // Prevent invalid form submit
    if (this.form.invalid) {
      console.warn("form", this.form);
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsTouched();
      });
      this.toastrService.error(
        this.translateService.instant("common.errors.form_is_invalid")
      );
      return;
    }

    // Activate submit button loading status
    this.formBtnOptions.active = true;

    if (this.model && this.propertyModel) {
      this.docsSelected.forEach((doc) => {
        if (doc.structureSelected && Array.isArray(doc.structureSelected)) {
          doc.structureSelected = doc.structureSelected.filter(
            (struct) => struct.value
          );
        }
      });
      let dataToSend = {};
      if (this.docType === "digital") {
        dataToSend = {
          data: this.form.value,
          docsSelected: this.docsSelected,
          documentFile: this.form.value.documentFile,
          contratti: this.contratti,
        };
        if (this.structureSelected.length) {
          dataToSend = {
            ...dataToSend,
            structureSelected: this.structureSelected,
          };
        }
        if (this.subscriptionType === "FREE" || this.subscriptionType === 'FREEBASIC') {
          dataToSend = {
            ...dataToSend,
            structureSelected: this.selectedStructureFree,
          };
        }
        this.subscriptions.push(
          this.documentArchivesService
            .updateMultiDoc(this.documentArchive._id, dataToSend)
            .pipe(finalize(() => (this.formBtnOptions.active = false)))
            .subscribe(
              (res) => {
                if (res.status) {
                  if (res.data && typeof res.data === "string") {
                    this.docUploaded = true;
                    this.options.formState = {
                      disabled: true,
                    };
                    // Disable form fields
                    Object.keys(this.form.controls).forEach((key) => {
                      const control = this.form.controls[key];
                      if (control) {
                        control.disable();
                      }
                    });

                    if (res.data && typeof res.data === "string") {
                      this.code = res.data.toUpperCase();
                    }

                    this.toastrService.success(res.message);

                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  }
                  this.toastrService.success(res.message);
                }
              },
              (err) => {
                this.helperService.handleFormlyError(this.form, err);
              }
            )
        );
      } else if (this.docType === "paper") {
        // First file is not required and name is equal to barcode - 2021-07-10
        if (!this.model.numFiles || !this.model.files) {
          this.model.numFiles = 1;
          this.model.files = [
            {
              docType: "",
              name: this.code,
            },
          ];
        }
        dataToSend = {
          data: {
            ...withoutAllFilesDocType(this.model),
            ...this.propertyModel,
            code: this.code,
            area: this.selectedArea,
          },
          docsSelected: this.docsSelected,
          documentFile: this.form.value.documentFile,
          contratti: this.contratti,
        };

        if (this.structureSelected.length) {
          dataToSend = {
            ...dataToSend,
            structureSelected: this.structureSelected,
          };
        }
        if (this.subscriptionType === "FREE" || this.subscriptionType === 'FREEBASIC') {
          dataToSend = {
            ...dataToSend,
            structureSelected: this.selectedStructureFree,
          };
        }

        this.subscriptions.push(
          this.documentArchivesService
            .updateMultiPaperDoc(this.documentArchiveId, dataToSend)
            .pipe(finalize(() => (this.formBtnOptions.active = false)))
            .subscribe(
              (res) => {
                if (res.status) {
                  this.docUploaded = true;
                  this.options.formState = {
                    disabled: true,
                  };
                  // Disable form fields
                  Object.keys(this.form.controls).forEach((key) => {
                    const control = this.form.controls[key];
                    if (control) {
                      control.disable();
                    }
                  });

                  this.toastrService.success(res.message);

                  window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }
              },
              (err) => {
                this.helperService.handleError(err);
                this.helperService.handleFormlyError(this.form, err);
              }
            )
        );
      }
    }
  }

  /**
   * Handle print file qrCode
   *
   * @since 1.0.0
   */
  onPrint(target: string): void {
    const qrCodes = [];
    if (this.model.files && this.model.files.length) {
      this.model.files.forEach((file) => {
        if (file.name) {
          qrCodes.push(file.name);
        }
      });
    } else if (this.model.documentFile && this.model.documentFile.length) {
      // If we're here we have a digital doc
      qrCodes.push(this.code);
    } else {
      // Paper doc: First file is not required and name is equal to barcode - 2021-07-10
      qrCodes.push(this.code);
    }
    if (!qrCodes.length) {
      this.toastrService.error("No qrCodes to inject");
      return;
    }

    let data;

    if (target === "qr") {
      data = {
        target,
        qrCodes,
        propertyName: this.propertyData.name,
        propertyCity: this.propertyData.address.city,
        propertyAddress: `${this.propertyData.address.route}, ${this.propertyData.address.streetNumber}`,
        area: this.selectedArea,
        docs: this.docsSelected,
      };
    } else if (target === "module") {
      data = {
        target,
        qrCodes,
        propertyName: this.propertyData.name,
        propertyCity: this.propertyData.address.city,
        propertyAddress: `${this.propertyData.address.route}, ${this.propertyData.address.streetNumber}`,
        area: this.selectedArea,
        uploadDate: new Date(),
        content: this.model.contenutoDocumento,
        docs: this.docsSelected,
        structures: this.structureSelected.filter((el) => el.value),
      };
    } else {
      this.toastrService.error("missing print target");
    }

    // Open dialog
    this.dialog.open(PrintQrDialogComponent, {
      data,
      width: "600px",
    });
  }

  /**
   * Export properties in a file with given format
   *
   * @since 1.0.0
   */
  onExport(target?: string, propertyId?: string): void {
    // If target is not provided, than just export all properties
    if (!target) {
      const date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
      const fileName = `${this.translateService.instant(
        "properties.list.exportFileName"
      )} ${date}`;
      this.subscriptions.push(
        this.propertiesService.getExport().subscribe(
          (res) => {
            const fileBlob = res;
            const blob = new Blob([fileBlob], {
              type: "application/vnd.ms-excel",
            });
            FileSaver.saveAs(blob, `${fileName}.xlsx`);
            // FileSaver.saveAs(blob, `${fileName}.xlsx`);
          },
          (err) => {
            this.helperService.handleError(err);
          }
        )
      );
    } else if (target && typeof propertyId !== "undefined") {
      // Handle export for missing/inserted documents
      const date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
      const fileName = `${this.translateService.instant(
        `properties.list.${target}`
      )} ${date}`;
      this.subscriptions.push(
        this.propertiesService.getDocExport(target, propertyId).subscribe(
          (res) => {
            const fileBlob = res;
            const blob = new Blob([fileBlob], {
              type: "application/vnd.ms-excel",
            });
            FileSaver.saveAs(blob, `${fileName}.xlsx`);
          },
          (err) => {
            this.helperService.handleError(err);
          }
        )
      );
    }
  }
}
